const o=(o,t,c)=>-c*o+c*t+o;export{o as mix};
